import { render } from "./instance_specific_panel.vue?vue&type=template&id=707b4e95"
import script from "./instance_specific_panel.js?vue&type=script&lang=js"
export * from "./instance_specific_panel.js?vue&type=script&lang=js"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__